import React from "react"
import styles from "./RecommendOffers.module.css"
import { SearchIcon } from "./icons"

type MoreOffersCardProps = {
    /** 求人一覧への遷移先URL */
    href: string
    analyticsLabel: string
}

// 「他の求人を見る」求人一覧遷移カード
export default function MoreOffersCard({
    href,
    analyticsLabel,
}: MoreOffersCardProps) {
    return (
        <div className={styles.moreCard} data-view-label={analyticsLabel}>
            <div className={styles.moreBody}>
                <SearchIcon className={styles.moreIcon} />
                <p className={styles.moreHeading}>
                    もっと求人を
                    <br />
                    見てみませんか？
                </p>
                <p className={styles.moreText}>
                    あなたに合う求人が
                    <br />
                    多数掲載中！
                </p>
            </div>
            <a
                href={href}
                className={styles.moreButton}
                data-click-label={`${analyticsLabel}-他の求人を見る-CTA`}
            >
                他の求人を見る ›
            </a>
        </div>
    )
}
